import { render } from "./TestWordOption.vue?vue&type=template&id=35b80d1f&scoped=true"
import script from "./TestWordOption.vue?vue&type=script&lang=js"
export * from "./TestWordOption.vue?vue&type=script&lang=js"

import "./TestWordOption.vue?vue&type=style&index=0&id=35b80d1f&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b80d1f"]])

export default __exports__